'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$22() {
  this.bgJ = null;
  this.bgH = null;
  this.bgI = false;
  this.bgF = null;
  this.bgG = false;
  this.bgK = false;
  this.bgL = false;
  this.bgJ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$22 as $c_Lpresto_PrestoRouter$$anon$22 };
$p = $c_Lpresto_PrestoRouter$$anon$22.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$22;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$22() {
}
export { $h_Lpresto_PrestoRouter$$anon$22 as $h_Lpresto_PrestoRouter$$anon$22 };
$h_Lpresto_PrestoRouter$$anon$22.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bgJ;
});
$p.t = (function() {
  if ((!this.bgI)) {
    this.bgH = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bgI = true;
  }
  return this.bgH;
});
$p.ag = (function() {
  if ((!this.bgG)) {
    this.bgF = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bgG = true;
  }
  return this.bgF;
});
$p.v = (function() {
  if ((!this.bgL)) {
    this.bgK = false;
    this.bgL = true;
  }
  return this.bgK;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$22 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$22, "presto.PrestoRouter$$anon$22", ({
  NV: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$22 as $d_Lpresto_PrestoRouter$$anon$22 };
//# sourceMappingURL=presto.-Presto-Router$$anon$22.js.map
